import urlParams from '../helpers/url-params';
/**
 * Two plugins for calling Isotope and PhotoSwipe with jQuery
 * .
 * To create the classic Nelios gallery call them both like this:
 *
 * $('#gallery').isotopeGallery(options).photoSwipeGallery(options);
 *
 */


/* global urlParams:false */
/* global PhotoSwipe */
/* global PhotoSwipeUI_Default */


/** Activate Isotope.
 *
 * Call on container element.
 *
 * @param options
 *
 * isotopeOptions: obj,      Parameter object for Isotope. If there are options set in the html they will overwrite this.
 * galleryFilters: selector  Selector for the filter links.
 * useUrlParams:   bool      Whether to use url parameters for filtering or not.
 *
 */

$.fn.isotopeGallery = function (options) {
    'use strict';

    const opt = $.extend({
        isotopeOptions: false,
        galleryFilters: '',
        useUrlParams: true
    }, options);

    $( this ).each(function() {

        const $gallery = $( this );

        // Use the options set in the html if they exist.
        const isotopeOptions = $gallery.data('isotope') ? $gallery.data('isotope') : opt.isotopeOptions ;

        if ( isotopeOptions ) {

            // If using url param check to see if it is set.
            if ( opt.useUrlParams && urlParams.get().filter && urlParams.get().filter !== '' ) {


                let filter = urlParams.get().filter;

                let filterClass = '.' + filter;
                $gallery.isotope({filter: filterClass });

                // Set 'active' class on filter links.
                $(opt.galleryFilters).removeClass('active');
                $(opt.galleryFilters).filter(function(){
                    return $(this).data('filter') === filter;
                }).first().addClass('active');
            }

            $gallery.isotope(isotopeOptions);

            // Set event listener on the filters.
            $(opt.galleryFilters).on('click', function() {

                let filterVal = $(this).attr('data-filter');

                $(this).addClass('active');
                $(opt.galleryFilters).not($(this)).removeClass('active');

                // If using url param, set it.
                if ( opt.useUrlParams ) {
                    urlParams.set({
                        filter: filterVal
                    });
                }

                // Apply the filter.
                if ( filterVal != '' ) {
                    $gallery.isotope({
                        filter: '.' + filterVal
                    });
                } else {
                    $gallery.isotope({
                        filter: function() {return true}
                    });
                }
            });
        }
    });

    return this;
};


/** Activate PhotoSwipe.
 *
 * Call on container element.
 *
 * @param options
 *
 * photoSwipeOptions: obj,      Parameter object for PhotoSwipe. If there are options set in the html they will overwrite this.
 * galleryFilters:    selector  Selector for the filter links. Leave empty if you don't need filtering.
 * useUrlParams:      bool      Whether to use url parameters for filtering or not.
 *
 */

$.fn.photoSwipeGallery = function (options) {
    'use strict';

    const opt = $.extend({
        photoSwipeOptions: false,
        galleryFilters: '',
        useUrlParams: true
    }, options);

    $( this ).each(function() {

        const $gallery = $( this );

        const photoSwipeOptions = $gallery.data('photoswipe-options') ? $gallery.data('photoswipe-options') : opt.photoSwipeOptions ;

        // The PhotoSwipe popup element.
        const pswpElement = document.querySelectorAll('.pswp')[0];

        // All gallery elements without filtering.
        const $allThumbnails = $gallery.find('a');

        // Helper function to pass data to PhotoSwipe.
        function setPhotoSwipeData($thumbnails) {

            let photoSwipeData = [];

            $thumbnails.each(function(index, item) {
                let swipeItem = {};
                let $slide = $(item);

                swipeItem.src = $slide.attr('href');
                swipeItem.w = $slide.data('width');
                swipeItem.h = $slide.data('height');
                swipeItem.title = $slide.data('title');
                swipeItem.cat = $slide.data('categories');

                photoSwipeData.push(swipeItem);
            });

            return photoSwipeData;
        }

        // A variable to hold the filtering value.
        let filter;

        function initPhotoSwipe( filter ) {

            // If using url params reset filter to url param.
            if ( opt.useUrlParams && urlParams.get().filter && urlParams.get().filter != '*' ) {
                filter = urlParams.get().filter;
            }

            // Filter the images.
            let $thumbnails = $allThumbnails.filter(function() {
                return $(this).data('categories').includes(filter);
            });

            // Set event listener on each image to init PhotoSwipe on click.
            $($thumbnails).each(function(index, item) {
                $(item).on('click', function(event) {
                    event.preventDefault();

                    let options = photoSwipeOptions;
                    options.index = index;

                    // Initialize PhotoSwipe
                    var lightBox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, setPhotoSwipeData($thumbnails), options);

                    lightBox.init();
                });
            });
        }

        // Init PhotoSwipe on load.
        initPhotoSwipe('');

        // If using filters add event listener on them.
        if ( opt.galleryFilters ) {
            $(opt.galleryFilters).on('click', function() {

                // If using url params, set them.
                if ( opt.useUrlParams ) {
                    urlParams.set({
                        filter: $(this).attr('data-filter')
                    });
                }

                filter = $(this).attr('data-filter');
                // Remove event listeners from previous PhotoSwipe instances.
                $allThumbnails.off();

                // Re-init PhotoSwipe with the current filter.
                initPhotoSwipe(filter);
            });
        }

    });

    return this;
};
